import React, { useState } from "react";
import { Icon } from "@coverme/icons";
import { InterviewNavigationDotSVG } from "../../../../components/InterviewNavigation/InterviewNavigationDotSVG";
import { pageUrlMapping } from "../../services/interviewWizardService";
import { Link, withRouter } from "react-router-dom";
import { OpenFacesheetIcon } from "../../../../components/MiniFacesheet/OpenFacesheetIcon";

export const InterviewSidebarSectionBase = ({
    title,
    children,
    currentSection = false,
    sectionName,
    match,
    wizardStatus,
    className = "",
    isSectionOpen=false,
    formSection
}) => {
    const isCurrentSection = currentSection === sectionName;
    const [isOpen, setIsOpen] = useState(isSectionOpen);
    const hasVisited = wizardStatus[sectionName];
    const path = pageUrlMapping[sectionName]?.url;
    const canExpand = hasVisited || sectionName === "documentation" || sectionName === "notes";

    return (
        <div
            className={`interview-sidebar-section ${isOpen && "open"} ${isCurrentSection && "current"} ${canExpand &&
                "expandable"} ${className}`}
        >
            <div className="title">
                <h3
                    onClick={() => {
                        if (canExpand) {
                            setIsOpen(!isOpen);
                        }
                    }}
                >
                    {title}
                    {isCurrentSection && <InterviewNavigationDotSVG />}
                </h3>
                <div className="icon-group">
                    {(hasVisited || formSection) && (
                        <>
                            {!isCurrentSection && (
                                <Link to={`${match.url}/${path}`}>
                                    <OpenFacesheetIcon />
                                </Link>
                            )}
                        </>
                    )}
                    {canExpand && (
                        <a onClick={() => setIsOpen(!isOpen)} href="javascript:void(0)">
                            <Icon icon={"arrow"} color={"blue"} height={"8"} />
                        </a>
                    )}
                </div>
            </div>
            <div className={`content`}>{children}</div>
        </div>
    );
};

export const InterviewSidebarSection = withRouter(InterviewSidebarSectionBase);
